import { Box, FormControl, Grid, IconButton, MenuItem, Select, Stack, Switch, TextField, Tooltip, Typography } from '@mui/material';
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import _ from 'lodash';
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import momenttz from "moment-timezone";
import "./ServiceAccounts.css"
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import WarningIcon from '@mui/icons-material/Warning';

const TemplateInfo = ({ planPoolToggle, selectedAccount, handlePlanPoolToggle, currentSubPool, handleSubPoolChange, isEditMode }) => {
    return (
        <>
            <Stack className="starlink-new-plans-container">
                <Box className="starlink-new-plans-item">
                    <Typography className="starlink-new-plans-label">Account Type</Typography>
                    <Box className="starlink-new-plans-type-select-wrapper">
                        <FormControl fullWidth size="small">
                            <Select value={planPoolToggle} onChange={(e) => handlePlanPoolToggle(e.target.value)}>
                                <MenuItem value="standard">Standard Account</MenuItem>
                                <MenuItem value="pooled">Pooled Account</MenuItem>
                            </Select>
                        </FormControl>
                        {/* <IconButton className="starlink-new-plans-type-icon" size="small">
                            <img className="starlink-create-plan-icon icon-cursor" src={planPoolToggle === "Plan" ? orgPoolIcon : customPlanIcon} />
                        </IconButton> */}
                    </Box>
                </Box>

                <Box className="starlink-new-plans-item">
                    <Typography className="starlink-new-plans-label">Account Nick Name</Typography>
                    <Typography className="starlink-new-plans-value-large">{selectedAccount?.accountName}</Typography>
                </Box>

                {planPoolToggle !== 'standard' &&
                    <>
                        <Box className="starlink-new-plans-item">
                            <Typography className="starlink-new-plans-label">Description</Typography>
                            <TextField
                                fullWidth
                                size="small"
                                placeholder="Enter a Description"
                                value={currentSubPool?.poolInfo}
                                onChange={(e) => handleSubPoolChange("poolInfo", e.target.value)}
                            />
                        </Box>
                        <Box className="starlink-new-plans-row">
                            <Box className="starlink-new-plans-item small">
                                <Box display="flex" alignItems="center" gap={0.5} width={"130px"}>
                                    <Typography className="starlink-new-plans-label">Account Size</Typography>
                                    <Tooltip title="The size of the Data Pool associated with this Account. This data will be used by Custom Plans. Data pool size and dates are not imported from Starlink, and changes here do not update the Starlink portal.">
                                        <span>
                                            <IconButton size="small" sx={{ color: "#ffd600" }}>
                                                <WarningIcon fontSize="small" />
                                            </IconButton>
                                        </span>
                                    </Tooltip>
                                </Box>
                                <TextField
                                fullWidth   
                                    size="small"
                                    type="number"
                                    value={currentSubPool.poolSize}
                                    disabled={isEditMode}
                                    onChange={(e) => handleSubPoolChange("poolSize", e.target.value)}
                                    placeholder="0"
                                    inputProps={{ min: 1 }}
                                />
                            </Box>

                            <Box className="starlink-new-plans-item small">
                                <Typography className="starlink-new-plans-label invisible-label">Unit</Typography>
                                <FormControl fullWidth size="small">
                                    <Select
                                        disabled={isEditMode || planPoolToggle === 'standard'}
                                        value={currentSubPool.poolUnit}
                                        onChange={(e) => handleSubPoolChange("poolUnit", e.target.value)}
                                    >
                                        <MenuItem value="gb">GB</MenuItem>
                                        <MenuItem value="tb">TB</MenuItem>
                                    </Select>
                                </FormControl>
                            </Box>

                            <Box
                                className="starlink-new-plans-item medium"
                                display="flex"
                                flexDirection="column"
                                justifyContent="flex-start"
                            >
                                <Typography className="starlink-new-plans-label">Recurring</Typography>
                                <Box height="37px" display="flex" alignItems="center">
                                    <label className="if-switch-toggle" style={{ marginTop: '2px' }}>
                                        <input
                                            type="checkbox"
                                            disabled
                                            checked={currentSubPool.isRecurring}
                                            onChange={(e) => handleSubPoolChange("isRecurring", e.target.checked)}
                                        />
                                        <span className="if-slider-toggle" />
                                    </label>
                                </Box>
                            </Box>

                            <Grid container spacing={1}>
                                {['Start Date', 'End Date'].map((label, index) => (
                                    <Grid item xs={6} key={label}>
                                        <Typography className="starlink-new-plans-label">{label}</Typography>
                                        <LocalizationProvider dateAdapter={AdapterMoment}>
                                            <DatePicker
                                                value={index === 0 ? currentSubPool.startDate : currentSubPool.endDate}
                                                onChange={(newValue) =>
                                                    handleSubPoolChange(index === 0 ? 'startDate' : 'endDate', newValue)
                                                }
                                                slotProps={{
                                                    textField: {
                                                        className: 'starlink-new-service-account-datepicker',
                                                        InputLabelProps: { className: 'starlink-new-service-account-label' },
                                                    },
                                                }}
                                            />
                                        </LocalizationProvider>
                                    </Grid>
                                ))}
                            </Grid>


                        </Box> </>}
            </Stack>
        </>
    );
};

const mapStateToProps = (state) => ({
});

export default withRouter(
    connect(mapStateToProps, {})(TemplateInfo)
)